import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import {Anchor, Avatar, Flexbox, Label} from "../../common/fusion-ui";
import {
    clearUserSessionData,
    getAllocatedModuleName,
    getUserSessionData,
    getUserSessionField,
    isAppThemeDark,
    isAppThemeLight,
    isCurrUserRoleAdmin,
    isModuleAllocated,
    printError,
    printLog,
    sendRequest
} from "../utils/AppUtils";
import {GenRouteUrls, Keys, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls, ShareFeatureModules, ThemeTypes} from "../config/AppConfig";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    clearBrowserCookie,
    getDefStr,
    getJsonValue,
    isBoolTrue,
    isValueBool,
    setCookieInBrowser
} from "../../common/fusion-ui/utils/ReactUtils";
import {DashSearchView, PageLinkSharePanel, ThemedButton, ThemedDropdownMenu, ThemedIconButton} from "../index";
import {useTheme} from "../../common/ProjectThemeProvider";
import {Menu, MenuItem} from "@mui/material";
import {useConfig} from "../context/ConfigProvider";
import useScreenSize from "../../common/fusion-ui/hook/useScreenSize";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";

const AppNavbar = React.memo(({showHome = false}) => {
    const TAG = "AppNavbar";

    const theme = useTheme();
    const {getConfig, isConfigTrue, updateConfig} = useConfig();
    const {isScreenUpSm} = useScreenSize();
    const {showToast, changeToastVariant} = useToast();

    const NAV_ITEM_HEIGHT = '28px';
    const ADD_EVENT_TYPES = [
        isModuleAllocated(Modules.Meetings) && {
            name: `Create Meeting`,
            link: GenRouteUrls.meeting_uploadPage
        },
        isModuleAllocated(Modules.WebMeeting) && {
            name: `Create ${getAllocatedModuleName(Modules.WebMeeting)}`,
            link: GenRouteUrls.wm_uploadPage
        },
        isModuleAllocated(Modules.DiscussionForum) && {
            name: `Create Forum`,
            link: GenRouteUrls.df_uploadPage
        },
        isModuleAllocated(Modules.Survey) && {
            name: `Create ${getAllocatedModuleName(Modules.Survey)}`,
            link: GenRouteUrls.survey_uploadPage
        }
    ].filter(item => checkNullJson(item) && !isValueBool(item));

    const Fields = {
        userFullName: 'userFullName',
        userFirstName: 'userFirstName',
        userLastName: 'userLastName',
        userEmail: 'userEmail',
        userMobile: 'userMobile',
        userImage: 'userImage',
        messagesNotifCount: 'messagesNotifCount',
        avatarDropdownAnchorEl: 'avatarDropdownAnchorEl',
        isDataFetched: 'isDataFetched',

        addEventSelectedOption: 'addEventSelectedOption',
        showSharePanel: 'showSharePanel',
    };
    const [fieldsData, setFieldsData] = useState({});
    const openMenu = Boolean(getField(Fields.avatarDropdownAnchorEl));

    useEffect(() => {
        loadUserData();
    }, []);

    return (<>
        <div
            className={`position-fixed w-100 px-0 py-2 top-0`}
            style={{
                zIndex: 10, backgroundColor: theme.bg, boxShadow: theme.boxShadowXs, // top: '0px',
                // padding: '.5rem 0 .5rem 0',
            }}
        >
            <Flexbox className={'px-2'} justifyAt={'between'} alignAt={'center'}>
                {/*left - controls*/}
                <Flexbox className={''} style={{marginTop: '-.2rem', flex: '1 1 0%'}} justifyAt={'start'} alignAt={'center'}>
                    {/*Logo*/}
                    <Link
                        to={ModuleRouteUrls[Modules.Home]}
                        onClick={() => {
                            updateConfig(Keys.config_navbarCurrPage, Modules.Home);
                            showHideRightPanels();
                        }}
                        style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}
                    >
                        <img
                            src="/vok_new_logo.png"
                            alt="VoK Logo"
                            style={{
                                height: '35px',
                                width: 'auto',
                                objectFit: 'contain'
                            }}
                        />
                    </Link>

                    {/* Spacer to align green buttons above the word 'Meeting' in 'Web Meeting' */}
                    {!isScreenResp() && <div style={{ width: '55px' }} />}

                    {/*Home btn - for testing only*/}
                    {(isBoolTrue(showHome)) && <ThemedButton
                        className={'text-nowrap'}
                        mr={3}
                        outlined={true}
                        sleek={true}
                        text={Modules.Home}
                        href={ModuleRouteUrls[Modules.Home]}
                        onClick={() => {
                            updateConfig(Keys.config_navbarCurrPage, Modules.Home);
                            showHideRightPanels();
                        }}
                    />}

                    {/*PeerProfiles btn*/}
                    {!isScreenResp() && isModuleAllocated(Modules.PeerProfiles) && <ThemedButton
                        className={'text-nowrap'}
                        mr={3}
                        variant={theme.primaryAlt}
                        bgColor={getCurrPage() == Modules.PeerProfiles ? theme.primaryAltDark : null}
                        color={getCurrPage() == Modules.PeerProfiles ? theme.textWhite : null}
                        sleek={true}
                        outlined={true}
                        text={getAllocatedModuleName(Modules.PeerProfiles)}
                        href={ModuleRouteUrls[Modules.PeerProfiles]}
                        onClick={() => {
                            updateConfig(Keys.config_navbarCurrPage, Modules.PeerProfiles);
                            showHideRightPanels();
                        }}
                    />}

                    {/*Messages btn*/}
                    {!isScreenResp() && isModuleAllocated(Modules.Messages) && <ThemedButton
                        className={'text-nowrap'}
                        mr={3}
                        variant={theme.primaryAlt}
                        bgColor={getCurrPage() == Modules.Messages ? theme.primaryAltDark : null}
                        color={getCurrPage() == Modules.Messages ? theme.textWhite : null}
                        sleek={true}
                        outlined={true}
                        text={getAllocatedModuleName(Modules.Messages)}
                        href={ModuleRouteUrls[Modules.Messages]}
                        onClick={() => {
                            updateConfig(Keys.config_navbarCurrPage, Modules.Messages);
                            showHideRightPanels();
                        }}
                    />}

                    {/*Meetings btn*/}
                    {!isScreenResp() && isModuleAllocated(Modules.Meetings) && <ThemedButton
                        className={'text-nowrap'}
                        mr={3}
                        variant={theme.primaryAlt}
                        bgColor={getCurrPage() == Modules.Meetings ? theme.primaryAltDark : theme.primaryAlt10}
                        color={getCurrPage() == Modules.Meetings ? theme.textWhite : null}
                        sleek={true}
                        outlined={true}
                        text={getAllocatedModuleName(Modules.Meetings)}
                        href={ModuleRouteUrls[Modules.Meetings]}
                        onClick={() => {
                            updateConfig(Keys.config_navbarCurrPage, Modules.Meetings);
                            showHideRightPanels();
                        }}
                    />}

                    {/*event dropdown (desktop only)*/}
                    {!isScreenResp() && isCurrUserRoleAdmin() && checkNullArr(ADD_EVENT_TYPES) && <ThemedDropdownMenu
                        className={''}
                        buttonClassName={'mx-2x text-nowrap border-1 border-primary'}
                        buttonHeight={'30px'}
                        outlined={false}
                        sleek={true}
                        showSelectedOption={false}
                        simpleLink={true}
                        enableRedirect={true}
                        textPrefix={<span className={'fw-semi-bold'}>
                            <span className={isScreenUpSm ? 'px-1' : 'pe-2'}><i className={'bi bi-calendar2-plus'}/></span>
                            {!isScreenUpSm && <span>Add Event</span>}
                        </span>}
                        defOption={''}
                        variant={'primaryBlue'}
                        buttonBgColor={theme.primaryBlue10}
                        buttonHoverBgColor={theme.primaryBlue}
                        buttonColor={theme.primaryBlueDark}
                        buttonHoverColor={theme.textWhite}>
                        {ADD_EVENT_TYPES}
                    </ThemedDropdownMenu>}

                    {/*event dropdown (mobile only)*/}
                    {isScreenResp() && isCurrUserRoleAdmin() && checkNullArr(ADD_EVENT_TYPES) && <ThemedDropdownMenu
                        className={''}
                        buttonClassName={'mx-2x text-nowrap border-1 border-primary'}
                        buttonHeight={'30px'}
                        outlined={false}
                        sleek={true}
                        showSelectedOption={false}
                        simpleLink={true}
                        enableRedirect={true}
                        textPrefix={<span className={'fw-semi-bold'}>
                            <span className={isScreenUpSm ? 'px-1' : 'pe-2'}><i className={'bi bi-calendar2-plus'}/></span>
                            {!isScreenUpSm && <span>Add Event</span>}
                        </span>}
                        defOption={''}
                        variant={'primaryBlue'}
                        buttonBgColor={theme.primaryBlue10}
                        buttonHoverBgColor={theme.primaryBlue}
                        buttonColor={theme.primaryBlueDark}
                        buttonHoverColor={theme.textWhite}>
                        {ADD_EVENT_TYPES}
                    </ThemedDropdownMenu>}

                    {/*search*/}
                    {(isScreenResp() && isModuleAllocated(Modules.Search) && isConfigTrue(Keys.config_showSearch) && !isBoolTrue(showHome)) && <div className={'mx-1'}>
                        <DashSearchView width={'auto'}/>
                    </div>}
                </Flexbox>

                {/*right - avatar & controls*/}
                <Flexbox style={{ flex: '1 1 0%' }} justifyAt={'end'} alignAt={'center'}>
                    {/*left-controls*/}
                    {!isScreenResp() && <Flexbox className={'ps-3'}
                                                 style={{marginTop: '-.3rem'}}
                                                 justifyAt={'center'}
                                                 alignAt={'start'}>
                        {/*recom-act btn*/}
                        {isModuleAllocated(Modules.RecommendActivity) && <ThemedButton
                            className={'text-nowrap'}
                            mx={2}
                            variant={theme.primaryBlue}
                            bgColor={getCurrPage() == Modules.RecommendActivity ? theme.primaryBlueDark : theme.primaryBlue10}
                            color={getCurrPage() == Modules.RecommendActivity ? theme.textWhite : null}
                            sleek={true}
                            outlined={true}
                            text={Modules.RecommendActivity}
                            href={ModuleRouteUrls[Modules.RecommendActivity]}
                        />}

                        {/*share*/}
                        {canShowShareButton() && <ThemedIconButton
                            className={''}
                            mx={2}
                            variant={theme.primaryAlt}
                            bgColor={'transparent'}
                            hoverBgColor={theme.primaryAlt}
                            color={theme.primaryAlt}
                            outlined={true}
                            tooltip={Modules.Share}
                            size={NAV_ITEM_HEIGHT}
                            icon={'fa fa-share'}
                            borderWidth={'2px'}
                            onClick={() => {
                                // toast('Share clicked');
                                updateField(Fields.showSharePanel, true);
                            }}
                        />}

                        {/*help btn*/}
                        {isConfigTrue(Keys.config_showHelp) && <ThemedIconButton
                            className={'fs-xl'}
                            mx={2}
                            variant={theme.primaryAlt}
                            bgColor={'transparent'}
                            hoverBgColor={theme.primaryAlt}
                            color={theme.primaryAlt}
                            outlined={true}
                            tooltip={'Help'}
                            size={NAV_ITEM_HEIGHT}
                            href={ModuleRouteUrls[Modules.Help]}
                            icon={'bi bi-question'}
                            borderWidth={'2px'}
                        />}
                    </Flexbox>}

                    {/*avatar*/}
                    <Flexbox className={'mx-2 me-3 ps-1'}
                             alignAt={'center'}
                             justifyAt={'center'}
                             wrap={'nowrap'}>
                        <span style={{marginBottom: '0rem'}}>
                            <Avatar wrapperClassName={''}
                                    className={'cursor-pointer'}
                                    imgClassName={'cursor-pointer'}
                                    bordered={true}
                                    variant={theme.primaryAlt}
                                    imgStyle={{
                                        borderColor: theme.primaryAlt, backgroundPosition: 'center',
                                    }}
                                    objectFit={'cover'}
                                    size={'38px'}
                                    showInitials={true}
                                    nameForInitials={getField(Fields.userFullName)}
                                    onImageClick={(e) => {
                                        updateField(Fields.avatarDropdownAnchorEl, e.currentTarget);
                                    }}>
                                {getField(Fields.userImage)}
                            </Avatar>
                        </span>
                    </Flexbox>

                </Flexbox>
            </Flexbox>
        </div>
        {createAvatarMenu()}
        {createSharePanel()}
    </>)

    function createAvatarMenu() {
        return <Menu
            className={"mt-1"}
            anchorEl={getField(Fields.avatarDropdownAnchorEl)}
            open={openMenu}
            onClose={closeAvatarMenu}
            slotProps={{
                paper: {
                    style: theme.dropdownMenuStyle,
                },
            }}
            sx={{
                '& .MuiPaper-root': {
                    backgroundColor: theme.dropdownMenuStyle.backgroundColor
                },
            }}>
            {/*user-img*/}
            <Avatar
                wrapperClassName={'select-none p-0 px-3 mt-1'}
                bordered={false}
                size={'75px'}
                showInitials={true}
                nameForInitials={getField(Fields.userFullName)}>
                {getField(Fields.userImage)}
            </Avatar>

            {/*full-name*/}
            <Label
                className={'m-0 p-0 mb-1x  px-3 fw-semi-bold mb-2'}
                widthClass={'100'}
                textAt={'center'}
                color={theme.text50}>
                {getField(Fields.userFullName)}
            </Label>

            {/*theme*/}
            <div
                className={'m-0 p-0 px-3 w-100 fw-semi-bold mb-3 flex-nowrap text-nowrap d-flexx d-none al-center jc-start cursor-default'}
            >
                <span className={"text-theme-resp"}>Theme</span>
                <div className={'w-auto d-flex flex-nowrap al-center jc-start cursor-pointer ps-2 bg-t'}>
                    {/*light-btn*/}
                    <div className={`p-2 d-flex jc-center al-center border-solid transition-sm highlight-dark-hover`}
                         style={{
                             width: '30px',
                             height: '30px',
                             borderRadius: '.4rem 0 0 .4rem',
                             borderWidth: '1.5px 0 1.5px 1.5px',
                             color: isAppThemeLight() ? theme.textDark : theme.textWhite,
                             backgroundColor: isAppThemeLight() ? theme.textWhite : theme.textDark,
                             borderColor: isAppThemeLight() ? theme.textDark : theme.textWhite,
                         }}
                         onClick={() => {
                             updateConfig(Keys.appTheme, ThemeTypes.light.text);
                             setCookieInBrowser({[Keys.appTheme]: ThemeTypes.light.text})
                         }}>
                        <span><i className={isAppThemeLight() ? 'bi bi-sun-fill' : 'bi bi-sun'}/></span>
                    </div>

                    {/*dark-btn*/}
                    <div className={`p-2 d-flex jc-center al-center border-solid transition-sm highlight-dark-hover`}
                         style={{
                             width: '30px',
                             height: '30px',
                             borderRadius: '0 .4rem .4rem 0',
                             borderWidth: '1.5px 1.5px 1.5px 1.5px',
                             color: isAppThemeDark() ? theme.textWhite : theme.textDark,
                             backgroundColor: isAppThemeDark() ? theme.textDark : theme.textWhite,
                             borderColor: isAppThemeDark() ? theme.textDark : theme.textWhite,
                         }}
                         onClick={() => {
                             updateConfig(Keys.appTheme, ThemeTypes.dark.text);
                             setCookieInBrowser({[Keys.appTheme]: ThemeTypes.dark.text})
                         }}>
                        <span><i className={isAppThemeDark() ? 'bi bi-moon-fill' : 'bi bi-moon'}/></span>
                    </div>
                </div>
            </div>

            {/*My ac*/}
            {createAvatarDropdownAnchorItem({
                moduleName: Modules.UserProfile,
                iconClass: 'bi bi-person'
            })}

            {/*RecommendActivity link*/}
            {isModuleAllocated(Modules.RecommendActivity) && createAvatarDropdownAnchorItem({
                moduleName: Modules.RecommendActivity,
                moduleNameAlt: getAllocatedModuleName(Modules.RecommendActivity),
                iconClass: 'bi bi-kanban',
                resp: true
            })}

            {/*PeerProfiles link*/}
            {isModuleAllocated(Modules.PeerProfiles) && createAvatarDropdownAnchorItem({
                moduleName: Modules.PeerProfiles,
                moduleNameAlt: getAllocatedModuleName(Modules.PeerProfiles),
                iconClass: 'bi bi-person-bounding-box',
                resp: true
            })}

            {/*Messages link*/}
            {isModuleAllocated(Modules.Messages) && createAvatarDropdownAnchorItem({
                moduleName: Modules.Messages,
                moduleNameAlt: getAllocatedModuleName(Modules.Messages),
                iconClass: 'bi bi-chat-dots',
                resp: true
            })}

            {/*Meetings link*/}
            {isModuleAllocated(Modules.Meetings) && createAvatarDropdownAnchorItem({
                moduleName: Modules.Meetings,
                moduleNameAlt: (Modules.Meetings),
                iconClass: 'bi bi-people',
                resp: true
            })}

            {/*share*/}
            {canShowShareButton() && createAvatarDropdownAnchorItem({
                moduleName: Modules.Share,
                iconClass: 'fa fa-share',
                resp: true,
                asLink: false, className: 'cursor-pointer',
                color: theme.text, onClick: () => {
                    // toast('Share clicked');
                    updateField(Fields.showSharePanel, true);
                }
            })}

            {/*Help link*/}
            {isConfigTrue(Keys.config_showHelp) && createAvatarDropdownAnchorItem({
                moduleName: Modules.Help,
                iconClass: 'bi bi-question-circle', resp: true
            })}

            {/*Logout*/}
            {<MenuItem
                className={`m-0 p-0 bg-t text-primary-hover transition-none`}
                onClick={() => closeAvatarMenu()}>
                <span
                    className={`m-0 p-0 py-1x mb-1x w-100 text-start  d-flex al-center jc-start flex-nowrap cursor-pointer transition-none text-primary-hover highlight-primary-hover rounded-3 select-none ${isScreenResp() ? 'px-2' : 'px-3'}`}
                    style={{color: theme.text, height: '28px'}}
                    onClick={handleLogout}>
                    <span><i className={`bi bi-box-arrow-right fs-normal pe-1`}/></span>
                    <span>{'Logout'}</span>
                </span>
            </MenuItem>}
        </Menu>
    }

    function createSharePanel() {
        return <PageLinkSharePanel
            open={isFieldTrue(Fields.showSharePanel)}
            customShareUrl={window.location.href}
            onHide={() => updateField(Fields.showSharePanel, false)}
            onSuccessAndHide={() => updateField(Fields.showSharePanel, false)}
        />
    }

    function createAvatarDropdownAnchorItem({
                                                moduleName,
                                                moduleNameAlt,
                                                moduleUrl,
                                                iconClass,
                                                resp,
                                                asLink = true,
                                                onClick,
                                                color,
                                                className,
                                                ...rest
                                            }) {
        return ((isBoolTrue(resp) && isScreenResp()) || !isBoolTrue(resp)) && <MenuItem
            className={`w-100x transition-none p-0 m-0x rounded-3 ${checkCurrPageMatch(moduleName) ? '' : `highlight-primary-hover highlight-primary-hover highlight-primary-focus text-primary-hovertext-primary-focus`}`}
            style={{
                height: '28px',
                margin: '0 0 .1rem 0',
                backgroundColor: checkCurrPageMatch(moduleName) ? theme.primaryBlue : '',
                color: checkCurrPageMatch(moduleName) ? theme.primaryBlue : '',
            }}
            onClick={() => {
                closeAvatarMenu();
                if (!checkCurrPageMatch(moduleName)) {
                    // const defaultUrl = getDefStr(getDefStr(moduleUrl, ModuleRouteUrls[moduleName]), window.location.href);
                    // // navigate(defaultUrl);
                    // try {
                    //     // const url = getEncodedUrlWithParam(defaultUrl);
                    //     // log('createAvatarDropdownAnchorItem.onClick.url:', url, 'defaultUrl:', defaultUrl);
                    //     // navigate(url);
                    // } catch (error) {
                    //     logErr('createAvatarDropdownAnchorItem.onClick.error:', error);
                    // }
                }
            }}>
            {(checkCurrPageMatch(moduleName) || !isBoolTrue(asLink)) ? <Label
                className={`w-100 d-flex flex-nowrap fd-row al-center h-100 jc-start text-nowrap px-2 transition-sm rounded-3 m-0 p-0 ${className} ${checkCurrPageMatch(moduleName) ? '' : 'text-primary-hover'}`}
                textAt={'start'}
                widthClass={'100'}
                color={getDefStr(color, theme.textWhite)}
                onClick={() => {
                    if (onClick) onClick();
                    showHideRightPanels();
                }}
                {...rest}
            >
                <i className={`${iconClass} fs-normal ${isScreenResp() ? 'px-0 pe-2' : 'px-1'}`}/>
                <span>{checkNullStr(moduleNameAlt) ? moduleNameAlt : moduleName}</span>
            </Label> : <Anchor
                wrapperClassName={'w-100'}
                className={`w-100 text-nowrap transition-sm rounded-3 p-0 m-0 px-2 cursor-pointer`}
                asLink={false}
                textAt={'start'}
                onClick={(e) => {
                    if (onClick) onClick();
                    showHideRightPanels();
                }}
                href={getDefStr(moduleUrl, ModuleRouteUrls[moduleName])}
                {...rest}
            >
                <i className={`${iconClass} fs-normal ${isScreenResp() ? 'px-0 pe-2' : 'px-1'}`}/>
                <span>{checkNullStr(moduleNameAlt) ? moduleNameAlt : moduleName}</span>
            </Anchor>}
        </MenuItem>
    }

    function checkCurrPageMatch(moduleName) {
        return checkNullStr(getCurrPage()) && getCurrPage() == moduleName;
    }

    function getCurrPage() {
        return getConfig(Keys.config_navbarCurrPage);
    }

    function handleLogout() {
        const fun = 'handleLogout:';
        try {
            const memberId = getUserSessionField(Keys.memberId);
            clearUserSessionData();
            clearBrowserCookie(null, true);
            window.location.href = GenRouteUrls.login;
            sendRequest({
                reqUrl: ReqUrls.logout,
                reqOptions: {[Keys.memberId]: memberId},
                onFetched: (fetchedData) => {
                    log(fun, 'fetchedData:', fetchedData);
                    // window.location.href = GenRouteUrls.login;
                }, onError: (error) => {
                    // window.location.href = GenRouteUrls.login;
                    logErr(fun, error);
                },
            });
        } catch (error) {
            logErr(fun, error);
        }
    }

    /**
     * Load user-profile data from local-storage.
     */
    function loadUserData() {
        const fun = 'loadUserData:';
        if (!isFieldTrue(Fields.isDataFetched)) {
            updateField(Fields.isDataFetched, true);
            try {
                const mf = ModuleFieldsData[Modules.UserProfile];

                const userData = getUserSessionData();
                // log(fun, 'userData:', userData);

                updateField(Fields.userFullName, getJsonValue(userData, mf.fullName.column));
                updateField(Fields.userFirstName, getJsonValue(userData, mf.firstName.column));
                updateField(Fields.userLastName, getJsonValue(userData, mf.lastName.column));
                updateField(Fields.userEmail, getJsonValue(userData, mf.memberEmail1.column));
                updateField(Fields.userMobile, getJsonValue(userData, mf.memberMobile1.column));
                updateField(Fields.userImage, getJsonValue(userData, mf.memberImage.column));
                updateField(Fields.messagesNotifCount, getJsonValue(userData, mf.totalLogin.column));//for testing only

            } catch (error) {
                logErr(fun, error);
                updateField(Fields.isDataFetched, false);
            }
        }
    }

    function showHideRightPanels(show = true) {
        updateConfig(Keys.config_showHomeRightPanels, show);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function isScreenResp() {
        return isScreenUpSm;
    }

    function canShowShareButton() {
        const tagMatched = ShareFeatureModules.some((item) => item.tag == getConfig(Keys.tracker_currPageTag));
        // log('canShowShareButton.currPageTag:', getConfig(Keys.tracker_currPageTag), 'tagMatched:', tagMatched);
        return (tagMatched && isCurrUserRoleAdmin() && isConfigTrue(Keys.config_showShare));
    }

    function closeAvatarMenu() {
        updateField(Fields.avatarDropdownAnchorEl, null);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default AppNavbar;
